"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetsList = void 0;
var BetsList_1 = require("./BetsList");
Object.defineProperty(exports, "BetsList", { enumerable: true, get: function () { return __importDefault(BetsList_1).default; } });
